module.exports = __webpack_public_path__ + "img/be-solve.77ca21d3.png";